export const TransactionListConstants = {
    GET_TRANSACTION_LIST_REQUEST: "GET_TRANSACTION_LIST_REQUEST",
    GET_TRANSACTION_LIST_SUCCESS: "GET_TRANSACTION_LIST_SUCCESS",
    GET_TRANSACTION_LIST_FAILURE: "GET_TRANSACTION_LIST_FAILURE",


    //get
    GET_FIATCURRENCY_LIST_REQUEST: "GET_FIATCURRENCY_LIST_REQUEST",
    GET_FIATCURRENCY_LIST_SUCCESS: "GET_FIATCURRENCY_LIST_SUCCESS",
    GET_FIATCURRENCY_LIST_FAILURE: "GET_FIATCURRENCY_LIST_FAILURE", 


    //update status
    UPDATE_FIATCURRENCY_STATUS_REQUEST: "GET_FIATCURRENCY_STATUS_REQUEST",
    UPDATE_FIATCURRENCY_STATUS_SUCCESS: "GET_FIATCURRENCY_STATUS_SUCCESS",
    UPDATE_FIATCURRENCY_STATUS_FAILURE: "GET_FIATCURRENCY_STATUS_FAILURE",

    GET_ORDERDEATILS_LIST_REQUEST: "GET_ORDERDEATILS_LIST_REQUEST",
    GET_ORDERDEATILS_LIST_SUCCESS: "GET_ORDERDEATILS_LIST_SUCCESS",
    GET_ORDERDEATILS_LIST_FAILURE: "GET_ORDERDEATILS_LIST_FAILURE",
}